import { render, staticRenderFns } from "./RepairCenter.vue?vue&type=template&id=1470a4a9&"
import script from "./RepairCenter.vue?vue&type=script&lang=js&"
export * from "./RepairCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports